export const truncate = (text, maxLength) =>
    typeof text === "string" && text.length > maxLength ? `${text.slice(0, maxLength)}...` : text;